import { Table } from 'antd';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { DashboardService } from '../../../../../services';
import TablePagination from '../../../../Table/pagination';
import { _empty } from '../../../../../screens/Modules/pme/screens/dashboard/widgets/recTable';
import { getLocales } from '../../../../Table/newTable';

const PER_PAGE = 20;

export default function EventTable({ selectedProject, columnsConfig, widget, typeOfEvent }) {
  const contRef = useRef();
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [options, setOptions] = useState({});

  const columns = useMemo(() =>
    columnsConfig({ t, language: i18next.language, options, contRef }), [t, options, columnsConfig]);

  const pages = useMemo(() => Math.ceil(total / PER_PAGE), [total]);

  const canGoNext = useMemo(() => {
    if (total === 0) {
      return false;
    }

    if (page !== pages) {
      return true;
    }

    return false;
  }, [page, pages, total]);

  const canGoPrev = useMemo(() => page !== 1, [page]);

  const _fetch = async () => {
    setLoading(true);
    try {
      const res = await DashboardService.getPmeProject({
        widget,
        pagination: {
          page: page,
          perPage: PER_PAGE,
        },
        filters: {
          typeOfEvent,
        }
      })
      if (res.data.supplyChainMonitoring) {
        const { data, metadata, options = {} } = res.data.supplyChainMonitoring;
        setOptions(options);
        setData(
          data.map((d, i) => ({
            ...d,
            key: `${i}-${d.id}`,
          }))
        );
        if (Array.isArray(metadata) && metadata[0]) {
          setTotal(metadata[0].total || 0);
        }
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    _fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, selectedProject]);

  return (
    <div className='overflow-section-2 daf-table-wrapper' ref={contRef}>
      <Table
        locale={getLocales(t)}
        columns={columns}
        dataSource={
          data.length ? data : _empty
        }
        scroll={{ y: 425 }}
        pagination={false}
        loading={loading}
      />
      <TablePagination
        t={t}
        page={page}
        totalPages={pages}
        goPrev={() => {
          if (loading) {
            return;
          }
          if (canGoPrev) {
            setPage(page - 1)
          }
        }}
        goNext={() => {
          if (loading) {
            return;
          }
          if (canGoNext) {
            setPage(page + 1)
          }
        }}
        canGoNext={canGoNext}
        canGoPrev={canGoPrev}
        totalItems={total}
        doTotalItems
        perPage={PER_PAGE}
      />
    </div>
  )
}
